export default {
    relatorioRede: {}
};
